import { Link, Outlet, useRouterState } from '@tanstack/react-router';
import { dv } from '../i18n/dv.ts';

const TABS = [
  { to: '/settings/users', label: dv.settings.usersTab },
  { to: '/settings/org', label: dv.settings.orgTab },
  { to: '/settings/address-book', label: dv.settings.addressBookTab },
] as const;

export function Settings(): JSX.Element {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <div className="page space-y-6 lg:space-y-8">
      <header>
        <h1 className="text-3xl font-bold tracking-tight">{dv.settings.title}</h1>
      </header>
      <nav aria-label={dv.settings.title} className="flex flex-wrap items-center gap-2 rounded-3xl bg-[hsl(var(--chrome))] p-1.5 sm:rounded-full">
        {TABS.map((t) => {
          const active = pathname === t.to;
          return (
            <Link
              key={t.to}
              to={t.to}
              aria-current={active ? 'page' : undefined}
              className={`shrink-0 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                active
                  ? 'bg-[hsl(var(--secondary-container))] text-[hsl(var(--on-secondary-container))]'
                  : 'text-muted-foreground hover:bg-[hsl(var(--surface-high))] hover:text-foreground'
              }`}
            >
              {t.label}
            </Link>
          );
        })}
      </nav>
      <Outlet />
    </div>
  );
}
